import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    group: String
  }

  checkboxTargetConnected(checkbox) {
    const groups = checkbox.dataset.checkboxesGroupValue.split(" ")
    groups.forEach(group => {
      const groupCheckbox = this.element.querySelector(`[data-checkboxes-group="${group}"]`)
      if (groupCheckbox && groupCheckbox.checked) {
        checkbox.checked = true
      }
    })
  }

  toggleAll(event) {
    const checked = event.target.checked
    const group = event.target.dataset.checkboxesGroup

    this.checkboxTargets.forEach(checkbox => {
      const checkboxGroups = checkbox.dataset.checkboxesGroupValue
      if (checkboxGroups.indexOf(group) > -1) {
        checkbox.checked = checked
      }
    })
  }

  updateGroupCheckbox(event) {
    const checkbox = event.target
    const groups = checkbox.dataset.checkboxesGroupValue.split(" ")

    groups.forEach(group => {
      const groupCheckbox = this.element.querySelector(`[data-checkboxes-group="${group}"]`)
      if (groupCheckbox) {
        const relatedCheckboxes = this.checkboxTargets.filter(target =>
          target.dataset.checkboxesGroupValue.indexOf(group) > -1
        )
        groupCheckbox.checked = relatedCheckboxes.every(box => box.checked)
      }
    })
  }
}
